import { config, gameState, target_1, target_2, target_3, target_4, dartTarget } from '@js/state';

var flag = false; //Checks if the shapes are supposed to go up or down

export default class TutorialScene extends Phaser.Scene {
  constructor() {
    super({
      key: "TutorialScene",
    });
  }

  preload() { }

  create() {
    //@

    var dartHitAudio = this.sound.add("dartHitAudio").setVolume(0.1);
    var greenLitAudio = this.sound.add("greenLitAudio").setVolume(0.1);
    var correctAudio = this.sound.add("correctAudio").setVolume(0.1);
    var onShapeAudio = this.sound.add("onShapeAudio").setVolume(0.1);
    var confettiAudio = this.sound.add("confettiAudio").setVolume(0.05);

    for (let i = 1; i <= 3; i++) {
      config.audio["ta" + i] = this.sound.add("ta" + i).setVolume(0.1);
    }

    //Harsh

    let clicks = 0;

    this.add.sprite(config.width / 2, config.height / 2, "scene2BG").setScale(0.25);
    this.parachute = this.add.sprite(1180, 320, "parachute").setScale(0.8);

    this.cloudRight = this.add.sprite(1000, 300, "cloudRight").setScale(1);

    this.cartWheel = this.add.sprite(250, 400, "cartWheel").setScale(0.7).setAlpha(0.4);
    this.add.sprite(config.width / 2, config.height / 2 + 85, "shop");

    this.hangerLine1 = this.physics.add.sprite(341.5, 255, "hangerLine");
    this.hangerLine2 = this.physics.add.sprite(541.5, 255, "hangerLine");
    this.hangerLine3 = this.physics.add.sprite(741.5, 255, "hangerLine");
    this.hangerLine4 = this.physics.add.sprite(941.5, 255, "hangerLine");

    this.flagWave = this.add.sprite(config.width / 2 + 20, 278, "flagWave").setScale(0.8);
    this.anims.create({
      key: "wave",
      frames: this.anims.generateFrameNames("flagWave", {
        start: 0,
        end: 121,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: -1,
    });

    this.flagWave.play("wave");

    this.shopTop = this.add.sprite(config.width / 2, config.height / 2 - 205, "shopTop");

    this.shape1 = this.physics.add.sprite(341.5, 360, "shape1");
    this.shape2 = this.physics.add.sprite(541.5, 360, "shape2");
    this.shape3 = this.physics.add.sprite(741.5, 360, "shape3");
    this.shape4 = this.physics.add.sprite(941.5, 360, "shape4");

    this.handIcon = this.add.sprite(720, 409, "handIcon").setVisible(false).setOrigin(0);

    this.overlay = this.add.sprite(config.width / 2, config.height / 2, "overlay").setBlendMode(Phaser.BlendModes.MULTIPLY);

    this.tutorialText1 = this.add.image(config.width / 2, 445, "tutSceneText1");

    this.time.delayedCall(300, function () {
      config.audio.ta1.play();
    });

    this.tutorialText2 = this.add.image(config.width / 2, 190, "tutSceneText2").setVisible(false);
    this.tutorialText3 = this.add.image(config.width / 2, 190, "tutSceneText3").setVisible(false);
    this.fractionBoard = this.add.sprite(config.width / 2, config.height / 2 + 242, "fractionBoard");
    this.fraction = this.add.sprite(config.width / 2, config.height / 2 + 242, "fraction");

    this.maskImage = this.add.image(config.width / 2, config.height / 2 - 20, "mask").setVisible(false);
    this.mask = this.maskImage.createBitmapMask();

    this.shape1.setMask(this.mask);
    this.shape2.setMask(this.mask);
    this.shape3.setMask(this.mask);
    this.shape4.setMask(this.mask);
    this.hangerLine1.setMask(this.mask);
    this.hangerLine2.setMask(this.mask);
    this.hangerLine3.setMask(this.mask);
    this.hangerLine4.setMask(this.mask);

    // this.shapeOverEvent(this.shape1, onShapeAudio);
    // this.shapeOutEvent(this.shape1);
    // this.shapeOverEvent(this.shape2,onShapeAudio);
    // this.shapeOutEvent(this.shape2);
    this.shapeOverEvent(this.shape3, onShapeAudio);
    this.shapeOutEvent(this.shape3);
    // this.shapeOverEvent(this.shape4,onShapeAudio);
    // this.shapeOutEvent(this.shape4);

    this.nextButton = this.add.sprite(config.width - 145, config.height - 45, "nextButton").setInteractive({
      cursor: "pointer",
    });

    this.nextButton.on(
      "pointerover",
      function (pointer) {
        //this.nextButton.setTint(0xc4c4c4);
        this.nextButton.setTexture("nextHover");
      },
      this
    );

    this.nextButton.on(
      "pointerout",
      function (pointer) {
        //this.nextButton.setTint();
        this.nextButton.setTexture("nextButton");
      },
      this
    );

    this.nextButton.on(
      "pointerup",
      function (pointer) {
        clicks += 1;
        if (clicks == 1) {
          this.tutorialText2.visible = true;
          this.time.delayedCall(300, function () {
            config.audio.ta2.play();
            config.audio.ta1.stop();
          });

          this.tutorialText1.visible = false;
          this.shape1.setDepth(1);
          this.shape2.setDepth(1);
          this.shape3.setDepth(1);
          this.shape4.setDepth(1);
        } else if (clicks == 2) {
          this.input.setDefaultCursor("url(assets/CommonAssets/Pointer.cur), pointer");
          this.handIcon.setVisible(true).setDepth(10).setScale(0.8);
          this.tweens.add({
            targets: this.handIcon,
            duration: 400,
            y: 370,
            yoyo: true,
            loop: -1,
          });
          //this.shape1.setInteractive();
          //this.shape2.setInteractive();
          this.shape3.setInteractive();
          //this.shape4.setInteractive();
          this.tutorialText2.visible = false;
          this.time.delayedCall(300, function () {
            config.audio.ta3.play();
            config.audio.ta2.stop();
          });
          this.tutorialText3.visible = true;
          this.nextButton.destroy();
        }
      },
      this
    );

    this.shape3.on(
      "pointerup",
      function (pointer) {
        dartHitAudio.play();
        this.handIcon.destroy();

        this.tutorialText3.visible = false;

        this.shape1.removeInteractive();
        this.shape2.removeInteractive();
        this.shape3.removeInteractive();
        this.shape4.removeInteractive();

        this.overlay.destroy();
        this.shape3.setScale(1);
        this.dartHitAnim_3.play("hit_3").setDepth(2);
        this.time.delayedCall(
          1000,
          function () {
            this.shape3.setTint(0x3dd771);
            correctAudio.play(); //
          },
          [],
          this
        );

        //confetti animation
        this.time.delayedCall(2000, function () {
          confettiAudio.play();
        });
        this.correctAnswer.anims.playAfterDelay("celebrate", 2000).setDepth(3);

        this.shopTop.setDepth(3);
        this.time.delayedCall(
          1500,
          function () {
            this.dartHitAnim_3.setMask(this.mask);
            this.physics.moveToObject(this.shape1, target_1, 300);
            this.physics.moveToObject(this.shape2, target_2, 300);
            this.physics.moveToObject(this.shape4, target_4, 300);
            this.physics.moveToObject(this.hangerLine1, target_1, 300);
            this.physics.moveToObject(this.hangerLine2, target_2, 300);
            this.physics.moveToObject(this.hangerLine4, target_4, 300);
          },
          [],
          this
        );

        this.time.delayedCall(
          3000,
          function () {
            this.add.sprite(384, 106, "correctBulb").setDepth(4);
            greenLitAudio.play();
          },
          [],
          this
        );
        this.time.delayedCall(
          5000,
          function () {
            dartTarget.x = config.width / 2;
            dartTarget.y = 150;
            this.physics.moveToObject(this.hangerLine3, target_3, 300);
            this.physics.moveToObject(this.shape3, target_3, 300);
            this.physics.moveToObject(this.dartHitAnim_3, dartTarget, 300);
          },
          [],
          this
        );

        this.time.delayedCall(
          6500,
          function () {
            this.scene.start("GameScene");
          },
          [],
          this
        );
      },
      this
    );

    //tutorial button event ends

    //correct dart hit animations
    this.dartHitAnim_3 = this.physics.add.sprite(config.width / 2, config.height / 2, "dartHit_3");
    this.anims.create({
      key: "hit_3",
      frames: this.anims.generateFrameNames("dartHit_3", {
        start: 0,
        end: 60,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    //confetti animation - position changes based on correct answer position
    this.correctAnswer = this.add.sprite(741.5, 350, "confetti").setScale(0.5);
    this.anims.create({
      key: "celebrate",
      frames: this.anims.generateFrameNames("confetti", {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });
  }

  //function to get shapes go up

  spriteGoUp(object, target) {
    this.physics.moveToObject(object, target);
  }

  spriteGoDown(object, target) {
    this.physics.moveToObject(object, target);
  }

  shapeOverEvent(buttonName, audio) {
    buttonName.on("pointerover", function (pointer) {
      buttonName.setScale(1.15);
      audio.play();
    });
  }

  shapeOutEvent(buttonName) {
    buttonName.on("pointerout", function (pointer) {
      buttonName.setScale(1);
    });
  }

  update() {
    this.cartWheel.rotation += 0.001;

    if (this.cloudRight.x > -200) {
      this.cloudRight.x -= 0.2;
    } else {
      this.cloudRight.x = 1180;
    }

    this.parachute.y -= 0.1;
    if (this.parachute.y < -60) {
      this.parachute.y = 700;
    }
    if (flag == false) {
      if (this.shape1.body.speed > 0 && this.shape2.body.speed > 0 && this.shape4.body.speed > 0) {
        //  4 is our distance tolerance, i.e. how close the source can get to the target
        //  before it is considered as being there. The faster it moves, the more tolerance is required.
        if (
          Phaser.Math.Distance.Between(this.shape1.x, this.shape1.y, target_1.x, target_1.y) < 4 &&
          Phaser.Math.Distance.Between(this.shape2.x, this.shape2.y, target_2.x, target_2.y) < 4 &&
          Phaser.Math.Distance.Between(this.shape4.x, this.shape4.y, target_4.x, target_4.y) < 4
        ) {
          this.shape1.body.reset(target_1.x, target_1.y);
          this.shape2.body.reset(target_2.x, target_2.y);
          this.shape4.body.reset(target_4.x, target_4.y);
          this.hangerLine1.body.reset(target_1.x, target_1.y);
          this.hangerLine2.body.reset(target_2.x, target_2.y);
          this.hangerLine4.body.reset(target_4.x, target_4.y);
        }
      }

      if (
        this.shape3.body.speed > 0 &&
        this.dartHitAnim_3.body.speed > 0 &&
        Phaser.Math.Distance.Between(this.shape3.x, this.shape3.y, target_3.x, target_3.y) < 4
      ) {
        this.shape3.body.reset(target_3.x, target_3.y);
        this.dartHitAnim_3.body.reset(dartTarget.x, dartTarget.y);
        this.hangerLine3.body.reset(target_3.x, target_3.y);
      }
    }
  }
}
